export * from './enums.js';
export * from './auth.js';
export * from './meetings.js';
export * from './mom.js';
export * from './transcripts.js';
export * from './vocabulary.js';
export const RECORDING_CHUNK_MAX_BYTES = 10 * 1024 * 1024;
export const UPLOAD_MAX_BYTES = 500 * 1024 * 1024;
export const RECORDING_TIMESLICE_MS = 20_000;
export const TRANSCRIPT_IMPORT_MAX_BYTES = 5 * 1024 * 1024;
/** Extension that matches a MediaRecorder mime type, so the key never lies about the bytes. */
export function chunkExtensionForMime(mimeType) {
    const base = (mimeType ?? '').split(';')[0]?.trim().toLowerCase();
    if (base === 'audio/mp4' || base === 'video/mp4' || base === 'audio/x-m4a')
        return '.mp4';
    return '.webm';
}
/**
 * Chunk keys are scoped by attempt so that restarting a recording can never
 * splice the new fragments into the previous attempt's sequence.
 */
export function chunkObjectKey(meetingId, attempt, index, extension = '.webm') {
    return `recordings/${meetingId}/chunks/${attempt}/${String(index).padStart(5, '0')}${extension}`;
}
export function chunkPrefix(meetingId, attempt) {
    return `recordings/${meetingId}/chunks/${attempt}/`;
}
export function audioObjectKey(meetingId) {
    return `recordings/${meetingId}/audio.m4a`;
}
export function formatTimestamp(seconds) {
    const s = Math.max(0, Math.floor(seconds));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    const mm = String(m).padStart(2, '0');
    const ss = String(sec).padStart(2, '0');
    return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
//# sourceMappingURL=index.js.map